export const INDUSTRIES_TITLES = {
  agriculture: 'Agriculture',
  automotive: 'Automotive',
  finance: 'Banking and Financial Services',
  biotech: 'Biotechnology',
  chemical: 'Chemical',
  construction: 'Construction',
  consumer_goods: 'Consumer Goods',
  education: 'Education',
  energy: 'Energy & Utilities',
  entertainment: 'Entertainment',
  food_and_beverage: 'Food & Beverage',
  healthcare: 'Healthcare',
  hospitality: 'Hospitality and Tourism',
  information_technology: 'Information Technology (IT)',
  logistics: 'Logistics',
  manufacturing: 'Manufacturing',
  mining_and_metals: 'Mining & Metals',
  pharmaceuticals: 'Pharmaceuticals',
  professional_services: 'Professional Services',
  real_estate: 'Real Estate',
  retail: 'Retail',
  telecommunications: 'Telecommunications',
  textiles_and_apparel: 'Textiles & Apparel',
  transportation: 'Transportation',
  utilities: 'Utilities'
} 

export const INDUSTRIES_ICONS = {
  agriculture: 'agriculture',
  automotive: 'car-01',
  finance: 'bank',
  biotech: 'virus',
  chemical: 'beaker-02',
  construction: 'building-07',
  consumer_goods: 'shopping-bag-02',
  education: 'graduation-hat-02',
  energy: 'lightning-01', 
  entertainment: 'tv-03',
  food_and_beverage: 'cup',  
  healthcare: 'activity-heart',
  hospitality: 'briefcase-01',
  information_technology: 'cpu-chip-01',
  logistics: 'truck-02',
  manufacturing: 'tool-01',
  mining_and_metals: 'diamond-01',
  pharmaceuticals: 'medical-cross',
  professional_services: 'user-03',
  real_estate: 'home-02',
  retail: 'building-02',
  telecommunications: 'signal-02',
  textiles_and_apparel: 'apparel',
  transportation: 'tram',
  utilities: 'tool-02'
}